/** @format */
import { OAUTH_ERROR_CODE } from '@mpb-com/auth-sdk/client';
import { useRouter } from 'next/router';
import React, { useContext, useEffect } from 'react';

import {
    ApplicationContext,
    ModalSize,
} from '@toucan/client/global/application';

import { OAuthErrorModal } from './components/oauth-error-modal';
import { OAUTH_ERROR_PARAM } from './config/constants';
import { removeOAuthErrorFromUrl } from './helpers';

export const useOAuthErrorModal = (): void => {
    const router = useRouter();
    const { setModalContent, setModalVisible } = useContext(ApplicationContext);
    const hasOAuthError = router.query[OAUTH_ERROR_PARAM] === OAUTH_ERROR_CODE;

    useEffect(() => {
        if (!hasOAuthError) {
            return;
        }

        const showOAuthErrorModal = () => {
            setModalContent(<OAuthErrorModal />);
            setModalVisible(true, { size: ModalSize.MEDIUM });
        };

        // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Legacy code: do not use as an example.
        removeOAuthErrorFromUrl(router).finally(showOAuthErrorModal);
        // eslint-disable-next-line react-hooks/exhaustive-deps -- Legacy code: do not use as an example.
    }, [hasOAuthError]);
};
